(function ($) {

    $(document).ready(function(){

        let windowsWidth = $(window).outerWidth();

        if (windowsWidth <= 992) {

            $('.navbar-collapse').on('click', function() {
                $('.lv-navbar .navbar-toggler').click();
            });

            $('.navbar-nav').on('click', function(event) {
                event.stopPropagation();
            });
        }

        $('.nav-close').on('click', function(e) {
            e.preventDefault();
            $('.lv-navbar .navbar-toggler').click();
        });

        let dropdownEl = $('#tabMenu');

        if (dropdownEl.length) {
            let btn = $('#tabMenu ~ .dropdown-menu .dropdown-item');

            btn.on('click', function() {
                $($(this).data('bs-target')).click();
                dropdownEl.text($(this).text());
                btn.removeClass('active');
                $(this).addClass('active');
            });
        }

        // Added a scroll to the faq functionality when the faq content is hidde.
        let faqsContent = $('.faq-box');
        if (faqsContent.length) {
            $('.accordion-collapse').on('shown.bs.collapse', function(e) {
                if ($(this).is(e.target)) {
                    let topPos = $(this).closest('.accordion-item').offset().top;
                    let winPost = $(window).scrollTop();
                    if ((winPost + 200) > topPos) {
                        $('html,body').animate({
                            scrollTop: topPos - 120
                        }, 250);
                    }
                }
            });
        }

        let btnLearnMore = $('button.js-btn-learn-more');
        if (btnLearnMore.length) {
            $('button.js-btn-learn-more').removeClass('lv-hide');

            $('.js-btn-learn-more').on('click', function() {
                let href = $(this).data('href');

                if (href.length) {
                    let target = $(this).data('target');

                    if (target === '_blank') {
                        window.open(href, '_blank');
                    } else {
                        window.location.href = href;
                    }
                }
            });
        }
    });
})(jQuery);
